export default "New cars are in the works!";